var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-main-table',{staticClass:"my-4 ml-4",attrs:{"headers":_vm.orderItemsTableHeaders,"items":_vm.items,"rights-group":"rfq","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.partPricing",fn:function(ref){
var item = ref.item;
return [_c('core-table-unit-pricing',{attrs:{"item":item.part}})]}},{key:"item.partThickness",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v("\n      "+_vm._s(item.part.thickness)+" "+_vm._s(item.part.thickness ? 'mm' : '')+"\n    ")])]}},{key:"item.totalPrice",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v("\n      "+_vm._s(_vm.formatCurrency(_vm.getItemPrice(
          Object.assign({}, item.part, { quantity: item.quantity }))
          * item.quantity))+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }